import { z } from "zod";

import { subscriptionSchema } from "@/features/billing/models";
import { SCHEDULE_BLOCK_REASON } from "@/shared/domains/appointments/constants";
import { availableLanguageSchema, GENDER } from "@/shared/models";
import { PORTAL_USER_TYPE } from "./constants";

export const portalUserSchema = z.object({
  code: z.uuid(),
  patientId: z.string().nullable(),
  name: z.string(),
  email: z.email(),
  type: z.enum(PORTAL_USER_TYPE).nullable(),
  gender: z.enum(GENDER).nullable(),
  dateOfBirth: z.string().nullable(),
  heightFeet: z.number().nullable(),
  heightInches: z.number().nullable(),
  weightInPounds: z.number().nullable(),
  preferredLanguage: availableLanguageSchema,
  needsChangePassword: z.boolean(),
  embeddables: z
    .object({ needsInitialSync: z.boolean() })
    .nullable()
    .optional(),
  askForMedicationStatus: z.boolean(),
  subscriptions: z.array(subscriptionSchema),
  gym: z.string().nullable(),
  journeySupport: z
    .object({
      canSchedule: z.boolean(),
      firstTime: z.boolean(),
      journeySupportBlockReason: z.enum(SCHEDULE_BLOCK_REASON).nullable(),
    })
    .nullable(),
  referralCode: z.string(),
  consentedToMarketingEmails: z.boolean(),
  intercomJWT: z.string().nullable(),
  blackFriday: z
    .object({
      startsAt: z.iso.datetime({ offset: true }),
      endsAt: z.iso.datetime({ offset: true }),
    })
    .nullable(),
  phoneNumber: z.string(),
});
